var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.75a8.75 8.75 0 100-17.5 8.75 8.75 0 000 17.5zm-.73-7.292V5.625h1.46v5.833H9.27zm0 1.459v1.458h1.46v-1.458H9.27z",
    fill: "#F74F4F"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAxOC43NUMxNC44MzI1IDE4Ljc1IDE4Ljc1IDE0LjgzMjUgMTguNzUgMTBDMTguNzUgNS4xNjc1MSAxNC44MzI1IDEuMjUgMTAgMS4yNUM1LjE2NzUxIDEuMjUgMS4yNSA1LjE2NzUxIDEuMjUgMTBDMS4yNSAxNC44MzI1IDUuMTY3NTEgMTguNzUgMTAgMTguNzVaTTkuMjcwODQgMTEuNDU4M0w5LjI3MDg0IDUuNjI1SDEwLjcyOTJWMTEuNDU4M0g5LjI3MDg0Wk05LjI3MDg0IDEyLjkxNjdWMTQuMzc1SDEwLjcyOTJWMTIuOTE2N0g5LjI3MDg0WiIgZmlsbD0iI0Y3NEY0RiIvPgo8L3N2Zz4K";
export { SvgErrorIcon as ReactComponent };